// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3033":"0af49ff6","7329":"38932985","8409":"d859a259"}[chunkId] + ".chunk.css";
};